module.exports = __webpack_public_path__ + "static/media/S-7.74a2d28b.mp3";